import { Component, Inject, AfterViewInit } from '@angular/core';
import { OKTA_AUTH, OktaAuthStateService } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { AlertService } from './services/alert.service';
import { ApiService } from './services/api.service';
import { AuthService } from './services/auth.service';
import { UtilService } from './services/util.service';
import { NgClass } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [NgClass, HeaderComponent, RouterOutlet]
})
export class AppComponent implements AfterViewInit {
  title = 'Yellow Folder';

  isAuthenticated = false;

  constructor(
    @Inject(OKTA_AUTH) private readonly oktaAuth: OktaAuth,
    public authService: OktaAuthStateService,
    public yfAuth: AuthService,
    private readonly api: ApiService,
    private readonly alertService: AlertService,
    public util: UtilService,
  ) {}

  ngAfterViewInit(): void {
    // WCAG: Hide CDK overlay container from the accessibility tree to prevent
    // the axe 'region' landmark violation. CDK overlays (dialogs, tooltips,
    // menus) each manage their own ARIA roles/labels; the wrapper div itself
    // is purely structural and should not appear as unlabelled page content.
    const overlay = document.querySelector('.cdk-overlay-container');
    if (overlay) {
      overlay.setAttribute('aria-hidden', 'true');
    }
  }

  async ngOnInit(): Promise<void> {
    this.authService.authState$.subscribe(
      (authObj) => {
        if (this.isAuthenticated) {
          return;
        }

        if (authObj.accessToken?.claims.sub) {
          this.api
            .authenticateOkta(
              '' + authObj.accessToken?.claims.sub,
              '' + authObj.accessToken?.claims.uid,
              '' + authObj.accessToken?.accessToken
            )
            .subscribe(
              (res) => {
                this.yfAuth.saveUser(res);
                this.isAuthenticated = true; // Set the flag to true after successful authentication
              },
              (err) => {
                this.alertService.toast(err.message);
                alert('User failed to log in with Yellowfolder');
                this.logout();
              }
            );
        }
      },
      (error) => {
        this.alertService.toast(error.message);
        alert('User failed to log in with Yellowfolder-Okta');
        this.logout();
      }
    );
  }

  async login() {
    await this.oktaAuth.signInWithRedirect();
  }

  async logout() {
    try {
      await this.oktaAuth.revokeAccessToken();
      await this.oktaAuth.revokeRefreshToken();
      this.oktaAuth.closeSession();
      this.oktaAuth.tokenManager.clear();
      await this.oktaAuth.signOut();
      this.yfAuth.logout();
      localStorage.clear();
    } catch (error) {
      console.error(error);
    }
  }
}
